import React, { useContext } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';

import { AuthContext } from '../auth/authContext';
import { appRoutePaths, getFullAppRoutePath, hasGoBack } from '../Nav/nav.types';

import { AccountUserCreate } from './AccountUserCreate';
import { AccountUserUpdate } from './AccountUserUpdate';

export const AccountUserDetailRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  const { accountCacheResource, authUserCacheResource, callCenterCacheResource } = useContext(AuthContext);

  const cachedAccountQuery = accountCacheResource.useCacheQuery();
  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();
  const cachedCallCenterQuery = callCenterCacheResource.useCacheQuery();

  const isFetching =
    cachedAuthUserQuery.isFetching || cachedAccountQuery.isFetching || cachedCallCenterQuery.isFetching;

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar
        title={id === 'new' ? 'Account User Create' : 'Account User'}
        onBackClicked={() => {
          const locationState = location.state;
          if (hasGoBack(locationState)) {
            navigate(locationState.goBack.url);
          } else {
            navigate(getFullAppRoutePath(appRoutePaths.AccountUser));
          }
        }}
        onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer}
      />
      {id === 'new' ? (
        <AccountUserCreate
          isFetchingFromProps={isFetching}
          accountId={cachedAccountQuery?.data?.id}
          callCenterId={cachedCallCenterQuery?.data?.id}
          authUser={cachedAuthUserQuery?.data}
          onSave={(accountUser) => {
            navigate(`${getFullAppRoutePath(appRoutePaths.AccountUser)}/${accountUser.id}`, { replace: true });
          }}
        />
      ) : (
        <AccountUserUpdate accountUserId={id} authUser={cachedAuthUserQuery?.data} isFetchingFromProps={isFetching} />
      )}
    </FlexBox>
  );
};
